import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

import Modal from '../../shared/Modal/';

function ModalNotification({ message, open, onCancel, onOk }) {
  const handleOnOkClick = () => {
    onOk && onOk();
    onCancel();
  };

  const renderConfirmMessage = () => (
    <div className="modal-confirm-message">
      <Icon name="warning sign" color="yellow" />
      {message}
    </div>
  );
  return (
    <Modal
      visible={open}
      width={600}
      onCancel={onCancel}
      footer={
        <React.Fragment>
          {onOk === `search` && (
            <Button color="blue" onClick={handleOnOkClick}>
              <Icon name="check" /> Yes
            </Button>
          )}
          <Button color={'red'} onClick={onCancel}>
            <Icon name="close" /> Close
          </Button>
        </React.Fragment>
      }
    >
      {renderConfirmMessage()}
    </Modal>
  );
}

export default ModalNotification;
